import React from 'react';
import { Phone } from 'lucide-react';
import './CTABanner.css';

export default function CTABanner() {
  const scrollToQuote = () =>
    document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div className="cta-band">
      <h2>Ready to protect your home?</h2>
      <p>Get your free My Home Warranty quote in 3 minutes. No commitment, no inspection, no hassle.</p>
      <div className="cta-btns">
        <button className="cta-gold" onClick={scrollToQuote}>
          Get Free Quote Online
        </button>
        <a href="tel:18005550100" className="cta-ghost">
          <Phone size={15} strokeWidth={2} />
          Call (800) 555-0100
        </a>
      </div>
    </div>
  );
}
